import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MovementFilters } from '@repo/accounts-types'

const initialState: Record<string, MovementFilters> = {}

export const {
  actions: accountsBankingProductLoanReceiptsFiltersActions,
  reducer: accountsBankingProductLoanReceiptsFiltersReducer,
} = createSlice({
  name: '@accounts/master/filters/bankingProductLoanReceipts',
  initialState,
  reducers: {
    setFilter: (
      state,
      action: PayloadAction<{
        id: string
        filters: MovementFilters
      }>,
    ) => {
      state[action.payload.id] = action.payload.filters
    },
    clearFilter: (
      state,
      action: PayloadAction<{
        id: string
      }>,
    ) => {
      delete state[action.payload.id]
    },
    reset: () => initialState,
  },
})
